import React, {useState, useEffect} from 'react';
import OrderService from '../../Utils/API/orders';
import Modal from '../../Components/Miscellaneous/Modal';
import "react-step-progress-bar/styles.css";
import { ProgressBar, Step } from "react-step-progress-bar";
import { BsFillBoxSeamFill, BsTruck } from 'react-icons/bs';
import {TbNotes} from 'react-icons/tb';
import { FiFileText, FiPackage } from 'react-icons/fi';
import { Portal } from 'react-portal';
import AuthService from '../../AuthService';

const token = AuthService.getToken();

export default function Orders() {
    const [orders, setOrders] = useState([]);
    const [opened, setOpened] = useState(false);
    const [orderInfo, setOrderInfo] = useState(null);
    const [order, setOrder] = useState(null);

    useEffect(() => {
        const getOrders = async () => {
            const orders = await OrderService.getOrders();
            setOrders(orders);
        }
        getOrders();
    }, []);

    function close(){
        setOpened(false);
        setOrder(null);
        setOrderInfo(null);
    }

    async function open(orderData){
        console.log('Opening order:', orderData);
        setOpened(true);
        setOrder(orderData);
        const order = await OrderService.getOrder(orderData._id);
        console.log('Order info received:', order);
        setOrderInfo(order);
    }

    const getStatusColor = (status) => {
        switch(status) {
            case 'Created': return '#f59e0b';
            case 'Preparing': return '#3b82f6';
            case 'Shipped': return '#8b5cf6';
            case 'Delivered': return '#10b981';
            default: return '#6b7280';
        }
    };

    const getStatusText = (status) => {
        switch(status) {
            case 'Created': return 'En preparación';
            case 'Preparing': return 'Preparando';
            case 'Shipped': return 'Enviado';
            case 'Delivered': return 'Entregado';
            default: return status;
        }
    };

    return (
        <>
        <h2 style={{
            fontSize: '24px',
            fontWeight: '700',
            color: '#111827',
            margin: '0 0 24px 0',
            fontFamily: 'Inter, sans-serif'
        }}>
            Mis Pedidos
        </h2>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            {orders.length > 0 ? orders.map(order => (
                <div
                    key={order._id}
                    onClick={(e) => {
                        e.stopPropagation();
                        open(order);
                    }}
                    style={{
                        backgroundColor: '#fff',
                        border: '1px solid #e5e7eb',
                        borderRadius: '12px',
                        padding: '20px',
                        cursor: 'pointer',
                        transition: 'all 0.2s ease'
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.boxShadow = '0 4px 6px rgba(0,0,0,0.1)';
                        e.currentTarget.style.transform = 'translateY(-2px)';
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.boxShadow = 'none';
                        e.currentTarget.style.transform = 'translateY(0)';
                    }}
                >
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '12px' }}>
                        <div>
                            <h3 style={{
                                fontSize: '16px',
                                fontWeight: '600',
                                color: '#111827',
                                margin: '0 0 4px 0',
                                fontFamily: 'Inter, sans-serif'
                            }}>
                                Pedido #{order._id}
                            </h3>
                            <p style={{
                                fontSize: '14px',
                                color: '#6b7280',
                                margin: 0,
                                fontFamily: 'Inter, sans-serif'
                            }}>
                                {new Date(order.CreationDate).toLocaleDateString('es-ES', {
                                    year: 'numeric',
                                    month: 'long',
                                    day: 'numeric'
                                })}
                            </p>
                        </div>
                        <span style={{
                            backgroundColor: `${getStatusColor(order.Status)}15`,
                            color: getStatusColor(order.Status),
                            padding: '6px 12px',
                            borderRadius: '6px',
                            fontSize: '13px',
                            fontWeight: '600',
                            fontFamily: 'Inter, sans-serif'
                        }}>
                            {getStatusText(order.Status)}
                        </span>
                    </div>

                    <div style={{
                        display: 'flex',
                        gap: '16px',
                        fontSize: '14px',
                        color: '#6b7280',
                        fontFamily: 'Inter, sans-serif'
                    }}>
                        <span>
                            <strong style={{ color: '#111827' }}>{order.ProductsCount || order.Products?.length || 0}</strong> productos
                        </span>
                        <span>•</span>
                        <span>
                            <strong style={{ color: '#028322' }}>{order.TotalAmount?.toFixed(2)}€</strong>
                        </span>
                    </div>
                </div>
            )) : (
                <p style={{
                    fontSize: '14px',
                    color: '#6b7280',
                    fontFamily: 'Inter, sans-serif',
                    textAlign: 'center',
                    padding: '40px'
                }}>
                    No tienes pedidos todavía
                </p>
            )}
        </div>

        {(() => {
            console.log('Modal render check - opened:', opened, 'order:', order, 'orderInfo:', orderInfo);
            return opened && order ? <Portal>
            <Modal title={`Pedido #${order._id}`} isExpand opened={opened} close={close}>
                <div style={{
                    padding: '24px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '24px',
                    fontFamily: 'Inter, sans-serif'
                }}>
                    {/* Progress Bar */}
                    <div>
                        <ProgressBar
                            percent={orderInfo?.Status === 'Created' ? 30 : orderInfo?.Status === 'Preparing' ? 60 : 90}
                            filledBackground={orderInfo?.sourceApp === 'BarOffice' ? '#1e40af' : '#028322'}
                        >
                            <Step transition="scale">
                                {({ accomplished }) => (
                                    <div style={{
                                        padding: '10px',
                                        borderRadius: '8px',
                                        backgroundColor: accomplished ?
                                            (orderInfo?.sourceApp === 'BarOffice' ? '#1e40af' : '#028322')
                                            : '#e5e7eb',
                                        color: '#fff',
                                        fontWeight: '600',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>
                                        <TbNotes size={20}/>
                                    </div>
                                )}
                            </Step>
                            <Step transition="scale">
                                {({ accomplished }) => (
                                    <div style={{
                                        padding: '10px',
                                        borderRadius: '8px',
                                        backgroundColor: accomplished ?
                                            (orderInfo?.sourceApp === 'BarOffice' ? '#1e40af' : '#028322')
                                            : '#e5e7eb',
                                        color: '#fff',
                                        fontWeight: '600',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>
                                        <BsFillBoxSeamFill size={20}/>
                                    </div>
                                )}
                            </Step>
                            <Step transition="scale">
                                {({ accomplished }) => (
                                    <div style={{
                                        padding: '10px',
                                        borderRadius: '8px',
                                        backgroundColor: accomplished ?
                                            (orderInfo?.sourceApp === 'BarOffice' ? '#1e40af' : '#028322')
                                            : '#e5e7eb',
                                        color: '#fff',
                                        fontWeight: '600',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>
                                        <BsTruck size={20}/>
                                    </div>
                                )}
                            </Step>
                        </ProgressBar>
                    </div>

                    {/* Estado */}
                    <div style={{
                        backgroundColor: '#f9fafb',
                        padding: '16px',
                        borderRadius: '8px',
                        border: '1px solid #e5e7eb'
                    }}>
                        <p style={{
                            fontSize: '14px',
                            color: '#6b7280',
                            margin: '0 0 4px 0'
                        }}>
                            Estado del pedido
                        </p>
                        <p style={{
                            fontSize: '16px',
                            fontWeight: '600',
                            color: getStatusColor(orderInfo?.Status),
                            margin: 0
                        }}>
                            {getStatusText(orderInfo?.Status)}
                        </p>
                    </div>

                    {/* Botón factura */}
                    <button
                        onClick={() => {
                            window.open(`https://api.rb.beeapp.es/pdfViewer/${token}/${order._id}/new`, '_blank', 'width=600,height=800,scrollbars=no,resizable=no,toolbar=no,location=no,menubar=no,status=no');
                        }}
                        style={{
                            width: '100%',
                            padding: '12px 20px',
                            backgroundColor: '#028322',
                            color: '#fff',
                            border: 'none',
                            borderRadius: '8px',
                            fontSize: '14px',
                            fontWeight: '600',
                            fontFamily: 'Inter, sans-serif',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '8px'
                        }}
                        onMouseEnter={(e) => e.target.style.backgroundColor = '#026a1b'}
                        onMouseLeave={(e) => e.target.style.backgroundColor = '#028322'}
                    >
                        <FiFileText size={18} />
                        Ver factura
                    </button>

                    {/* Productos */}
                    <div>
                        <h3 style={{
                            fontSize: '16px',
                            fontWeight: '600',
                            color: '#111827',
                            margin: '0 0 16px 0',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px'
                        }}>
                            <FiPackage size={18} color="#028322" />
                            Productos
                        </h3>

                        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                            {orderInfo?.Products?.map((item, index) => {
                                // Usar product si existe, sino productSnapshot
                                const productData = item.product || item.productSnapshot;

                                // Si no hay ninguno, no mostrar
                                if (!productData) return null;

                                return (
                                    <div key={index} style={{
                                        display: 'flex',
                                        gap: '16px',
                                        padding: '16px',
                                        backgroundColor: '#f9fafb',
                                        borderRadius: '8px',
                                        border: '1px solid #e5e7eb'
                                    }}>
                                        <img
                                            src={productData.images?.[0] || productData.image || ''}
                                            alt={productData.name || 'Producto'}
                                            style={{
                                                width: '80px',
                                                height: '80px',
                                                objectFit: 'cover',
                                                borderRadius: '8px',
                                                border: '1px solid #e5e7eb',
                                                flexShrink: 0
                                            }}
                                        />
                                        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                                            <h4 style={{
                                                fontSize: '14px',
                                                fontWeight: '600',
                                                color: '#111827',
                                                margin: '0 0 4px 0'
                                            }}>
                                                {productData.name || 'Producto no disponible'}
                                            </h4>
                                            <p style={{
                                                fontSize: '13px',
                                                color: '#6b7280',
                                                margin: 0
                                            }}>
                                                Cantidad: {item.quantity}
                                            </p>
                                        </div>
                                        <div style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            padding: '8px 16px',
                                            backgroundColor: '#028322',
                                            color: '#fff',
                                            borderRadius: '8px',
                                            fontSize: '16px',
                                            fontWeight: '700',
                                            height: 'fit-content',
                                            alignSelf: 'center'
                                        }}>
                                            {item.quantity}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </Modal>
        </Portal> : null;
        })()}
        </>
    )
}